import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import BusOffers from "../../../Components/Advertisements/BusOffers";
import SearchBusPanel3 from "../SearchBusPanel/SearchBusPanel3";
import styles from "./SearchBus3.module.css";

const SearchBus3 = ({ styleConfig, mode, onNavigate, templateId, branding }) => { 
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  // Dynamic Theme: Warm Terracotta & Ivory
  const themeVariables = {
    "--primary-color": styleConfig?.primary || "#d97706", // Adventurous Burnt Orange
    "--secondary-color": styleConfig?.secondary || "#475569", // Slate Grey
  };

  const handleSearch = (searchQuery) => {
    if (mode === "builder") {
        onNavigate({ name: "bus-results", params: { searchQuery } });
    } else if (mode === "preview") {
        navigate(`/template-preview/${templateId}/bus-results`, { state: { searchQuery } });
    } else {
        navigate("/template/bus/results", { state: { searchQuery } });
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!user) navigate("/");

  return (
    <div id="layout-wrapper" style={themeVariables} className={styles.mainWrapper}>
      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          
          <div className={styles.layoutGrid}>
            <div className={styles.textContent}>
              <span className={styles.topTag}>#1 Rated Adventure Network</span>
              <h1 className={styles.mainTitle}>
                Discover the <br/>
                <span className={styles.italic}>Unexplored</span> Routes.
              </h1>
              <p className={styles.subText}>
                Luxury travel for the modern explorer. Experience India's most comfortable 
                and reliable long-distance bus network.
              </p>
              
              <div className={styles.trustRow}>
                <div className={styles.trustItem}>
                  <strong>1M+</strong>
                  <span>Happy Travelers</span>
                </div>
                <div className={styles.trustDivider}></div>
                <div className={styles.trustItem}>
                  <strong>4.8/5</strong>
                  <span>Safety Rating</span>
                </div>
              </div>
            </div>

            <div className={styles.visualContent}>
                {/* A bright, sun-drenched adventurous bus image */}
                <img 
                    src="https://images.unsplash.com/photo-1570125909232-eb263c188f7e?auto=format&fit=crop&q=80&w=1000" 
                    alt="Luxury Bus" 
                    className={styles.heroImg}
                />
                <div className={styles.floatingBadge}>
                    <span>Premium Fleet</span>
                </div>
            </div>
          </div>

          <div className={styles.searchContainer}>
             <SearchBusPanel3 
               styleConfig={styleConfig} 
               onSearch={handleSearch} 
               mode={mode} 
               onNavigate={onNavigate} 
               templateId={templateId} 
             />
          </div>
        </div>
      </section>

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <BusOffers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBus3;